import { z } from 'zod';

export const ZipcodeCity = z.object({
  zipcode: z.string(),
  city: z.string(),
  province: z.string(),
  city_zh: z.string(),
  province_zh: z.string(),
});

export type ZipcodeCity = z.infer<typeof ZipcodeCity>;
